import React from 'react';
import { CiInstagram, CiFacebook } from "react-icons/ci";
import "./Contact.css";
import { useTranslation } from 'react-i18next';

function Contact() {
    const { t, i18n } = useTranslation();
      
          const changeLanguage = (e) => {
            i18n.changeLanguage(e.target.value);
        };
    const handleSubmit = (e) => {
    e.preventDefault();

    // 1. Get data from the form
    const formData = new FormData(e.target);
    const nom = formData.get('Nom');
    const prenom = formData.get('Prenom');
    const sujet = formData.get('Sujet');
    const message = formData.get('Message');

    // 2. Define the recipient
    const emailTo = "contact@musee-loukach.ma";

    // 3. Construct the body (optional: adding the sender's name)
    const body = `Nom: ${nom} ${prenom}\n\nMessage:\n${message}`;

    // 4. Create the mailto link 
    // encodeURIComponent ensures special characters (like spaces) work in a URL
    const mailtoLink = `mailto:${emailTo}?subject=${encodeURIComponent(sujet)}&body=${encodeURIComponent(body)}`;

    // 5. Open the mail app
    window.location.href = mailtoLink;
  };

    return (
        <div className='contact-wrapper' data-aos="fade-up">
            <h2 className='contact-title titre'>
                {t('contact.title')}
            </h2>
            <div className='contact-container'>
                <section className='contact-info-section'>
                    <div className='info-content'>
                        <h1 className='info-heading titre'>
                            {t('contact.subtitle')}
                        </h1>
                        <p className='info-description plf'>
                            {t('contact.paragraph')}
                        </p>
                        <img src='/assets/icons/Frame.png' alt="Frame_contact" className="info-image" />
                    </div>
                    <div className='contact-details'>
                        {/* <p className='detail-item'><strong>Telephone</strong></p>
                        <p className='detail-value'>+212 500 00 00 00</p> */}
                        <p className='detail-item plf'><strong>{t('contact.email')}</strong></p>
                        <p className='detail-value plf'>{t('contact.email_value')}</p>
                        <p className='detail-item plf'><strong>{t('contact.adresse')}</strong></p>
                        <p className='detail-value plf'>{t('contact.adresse_value')}</p>

                        <div className='social-links'>
                            <a href='https://www.facebook.com/share/12LxW4mQF46/?mibextid=wwXIfr' className='social-icon'><CiFacebook /></a>
                            <a href='https://www.instagram.com/museeloukach/' className='social-icon'><CiInstagram /></a>
                        </div>
                    </div>
                </section>

                <section className='form-section'>
                    <div className='map-container'>
                        <iframe
                            title='map2'
                            className="map-frame"
                            frameBorder="0"
                            scrolling="no"
                            src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Madrasa%20Loukach&t=&z=13&ie=UTF8&iwloc=B&output=embed">
                        </iframe>
                    </div>

                    <form className='contact-form' onSubmit={handleSubmit} >
                        <div className="input-row">
                            <input type="text" name="Nom" placeholder={t('contact.form_nom')} required className="input-field" />
                            <input type="text" name="Prenom" placeholder={t('contact.form_prenom')} required className="input-field" />
                        </div>
                        <input type="text" name="Sujet" placeholder={t('contact.form_sujet')} required className="input-field full-width" />
                        <textarea name="Message" rows="6" placeholder={t('contact.form_message')} className="textarea-field"></textarea>
                        <button type="submit" className="submit-button plf">
                            {t('contact.form_button')}
                        </button>
                    </form>
                </section>
            </div>
        </div>
    );
}

export default Contact;